export default "/images/vendor/flag-icons/flags/4x3/in.svg?56c684671d65bd5f2ed6436c05a88eea";